import React, { useState } from 'react';
import './Footer.scss';
import FollowUs from './FollowUs';
import { connect } from 'react-redux';
import PowerUpdate from '../PowerUpdate/PowerUpdate';
import { bindActionCreators } from 'redux';
import * as footerActions from '../../../actionCreators/footer';

const Footer = props => {
  const footerData =
    props?.redisCommonData?.FOOTER_DATA && JSON.parse(props.redisCommonData.FOOTER_DATA);
  let mainSection;
  let bottomRow;
  let socialLinks;
  if (footerData?.desktop) {
    const footData = footerData.desktop;
    mainSection = footData.mainSection;
    bottomRow = footData.bottomRow;
    socialLinks = footData.socialLinks;
  }
  const [showPowerModal, setShowPowerModal] = useState(false);
  const {
    section,
    loginStatus,
    dataLocale,
    /* mainNavigationData, componentsData, location, */ redisCommonData,
    enterPowerRespMsg,
  } = props;
  const { DOWNLOAD_LENSKART_APP_BUY, DOWNLOADAPP_PRODUCTTYPE, FOLLOW_US_AT } = dataLocale;
  // const COMPANY_POLICY = [];
  // const extraLinks = COMPANY_POLICY;
  const hitPowerAPI = phoneVal => {
    footerActions.getPowerUpdate(phoneVal);
  };
  const handleFooterClickEvent = () => {
    setShowPowerModal(true);
  };
  const handleClick = (e, name, url) => {
    if (
      name &&
      typeof name === 'string' &&
      name.toUpperCase() === 'ENTER MY POWER' &&
      (url.indexOf('javascript') !== -1 || !url)
    ) {
      e.preventDefault();
      return handleFooterClickEvent();
    }
  };

  const close = () => {
    setShowPowerModal(false);
  };

  return (
    <div
      className={`footer footer-container ${
        section === 'cat' ? 'vertical-footer footer-overlap' : ''
      }`}
      id="footer-container"
    >
      <div className="customer-links padding-t40 padding-b40 display-flex align-items-center justify-space-between pos-rel">
        <div className="all-links display-flex justify-space-between">
          {mainSection?.map((ms, idx) => {
            return (
              <div key={idx} className="margin-r150">
                <h2 className="futura-pt fs20">{ms.sectionTitle}</h2>
                <div
                  className="display-flex justify-space-between fs20"
                  style={{ flexDirection: 'column' }}
                >
                  {ms.sectionChildren.map((subLink, i) => (
                    <a
                      key={i}
                      href={subLink.redirectUrl}
                      rel="noreferrer"
                      target={subLink.isNewTab ? '_blank' : '_self'}
                      onClick={e => handleClick(e, subLink.name, subLink.redirectUrl)}
                    >
                      <p className="futura-pt text-color-white padding-t10 text-capitalize fs14">
                        {subLink.name}
                      </p>
                    </a>
                  ))}
                </div>
              </div>
            );
          })}
        </div>
        <div
          className="download-app display-flex align-items-center justify-content-center pos-abs padding-30"
          data-testid="download-app"
          style={{ flexDirection: 'column' }}
        >
          <div className="margin-b20">
            <a href="/mobile-app">
              <img
                alt="play-store"
                className="margin-r5"
                src="https://static.lenskart.com/media/desktop/img/play-store.svg"
              />
            </a>
            <a href="/mobile-app">
              <img
                alt="app-store"
                src="https://static.lenskart.com/media/desktop/img/app-store.svg"
              />
            </a>
          </div>
          <span>{DOWNLOAD_LENSKART_APP_BUY} </span>
          <span>{DOWNLOADAPP_PRODUCTTYPE}</span>
        </div>
      </div>
      <div className="horz-line"></div>
      <div className="extra-info display-flex align-items-center justify-space-between">
        <div className="lenskart-links display-flex align-items-center justify-space-between">
          {bottomRow?.map((link, idx) => (
            <a
              key={idx}
              href={link.redirectUrl}
              rel="noreferrer"
              target={link.isNewTab ? '_blank' : '_self'}
            >
              <span className="padding-r40 text-color-white">{link.name}</span>
            </a>
          ))}
        </div>
        <div className="follow-links display-flex align-items-center" data-testid="follow-us">
          <span>{FOLLOW_US_AT}</span>
          <FollowUs
            dataLocale={dataLocale}
            followData={socialLinks}
            loginStatus={loginStatus}
            redisCommonData={redisCommonData}
            section={section}
          />
        </div>
      </div>
      <div className="dittoContainer_ditto screen-hidden" />
      {showPowerModal && (
        <PowerUpdate
          dataLocale={dataLocale}
          enterPowerRespMsg={enterPowerRespMsg}
          hideHandler={close}
          hitPowerAPI={hitPowerAPI}
          showModal={showPowerModal}
        ></PowerUpdate>
      )}
    </div>
  );
};

Footer.defaultProps = {
  mainNavigationData: {},
};

const mapStateToProps = state => {
  return {
    enterPowerRespMsg: state.footer.enterPowerRespMsg,
    dataLocale: state.locale,
    redisCommonData: state.common.redisCommonData,
    componentsData: state.home.homepageData.footers,
  };
};
function mapDispatchToProps(dispatch) {
  return {
    footerActions: bindActionCreators(footerActions, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Footer);
